module.exports = __webpack_public_path__ + "img/favicon.ca869b86.png";